<template>
  <form @submit.prevent="submit()">
    <b-row>
      <b-col sm="4">
        <div class="form-group">
          <label
            for="customfield_label"
            class="form-control-label">{{$t('views.externalform.form.nameField')}}:</label>
          <input
            id="customfield_label"
            v-model="item.label"
            :class="['form-control', isInvalid('label') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
          >
          <div
            v-if="isInvalid('label')"
            class="invalid-feedback">{{ violations.label }}</div>
        </div>
      </b-col>
      <b-col sm="4">
        <div class="form-group">
          <label
            for="customfield_tooltip"
            class="form-control-tooltip">{{$t('views.externalform.form.tooltip')}}:</label>
          <input
            id="customfield_tooltip"
            v-model="item.tooltip"
            :class="['form-control', isInvalid('tooltip') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
          >
          <div
            v-if="isInvalid('tooltip')"
            class="invalid-feedback">{{ violations.tooltip }}</div>
        </div>
      </b-col>
      <b-col sm="4">
        <div class="form-group">
          <label
            for="customfield_fieldtype"
            class="form-control-label">{{$t('views.externalform.form.fieldType')}}:</label>
          <model-select
            id="customfield_fieldtype"
            :options="customFieldTypeOptions"
            v-model="item.customFieldType">
          </model-select>
          <div
            v-if="isInvalid('fieldType')"
            class="invalid-feedback">{{ violations.customFieldType }}</div>
        </div>
      </b-col>
      <b-col sm="4">
        <label>{{$t("views.externalform.form.displayField")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="checkbox_display" v-model="item.display" name="checkbox_display">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <label>{{$t("views.externalform.form.requiredField")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="checkbox_required" v-model="item.required" name="checkbox_required">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <label>{{$t("views.externalform.form.orderField")}}:</label>
        <input
          class="form-control"
          v-model="item.orderCustomField"
          id="order_field"
          type="number">
      </b-col>
      <b-col sm="4">
        <label>{{$t("views.externalform.form.showOnExternalForm")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="checkbox_display" v-model="item.showOnExternalForm" name="checkbox_display">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <label>{{$t("views.externalform.form.showOnAgreement")}}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="checkbox_required" v-model="item.showOnAgreement" name="checkbox_required">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <table  class="table table-responsive-md table-sm table-hover table-striped">
          <tbody>
            <tr v-if="item.customFieldType === 4">
              <td class="table-light" colspan="2">
                <div  class="form-group pl-2 pr-2">
                  <label class="w-100"><b>{{$t("views.externalform.form.customFieldValues")}}</b></label>
                  <div class="row" v-for="(customFieldValue, fieldValueIndex) in item.customFieldValues" :key="'field_'+fieldValueIndex">
                    <div class="col-lg-4 mb-3">
                      <input v-model="customFieldValue.text"
                             class="form-control"
                             :id="'customFieldText' + fieldValueIndex"/>
                    </div>
                    <div class="col-lg-4 mb-3">
                      <input v-model="customFieldValue.value"
                             class="form-control"
                             :id="'customFieldValue' + fieldValueIndex"/>
                    </div>
                    <div class="col-lg-4 mt-1">
                      <button type="button" class="btn btn-warning btn-sm" @click="removeFieldFromCustomField(fieldValueIndex)"><i class="fa fa-trash mr-2"></i></button>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-warning btn-sm"
                    @click="addNewFieldToCustomField()"
                  >
                    <i class="fa fa-plus mr-2"></i>
                    {{ $t('views.externalform.form.addNewFieldToCustomField') }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import { mapMutations, mapGetters } from 'vuex'
// import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations'],
  components: {
    ModelSelect
  },

  data () {
    return {
    }
  },

  beforeDestroy () {
    this.reset()
  },

  computed: {
    ...mapGetters({
      customFieldTypeOptions: 'customfields/list/customFieldTypeOptions'
    }),

    item () {
      return typeof this.values !== 'undefined' ? this.values : this.initialValues
    }
  },

  methods: {
    ...mapMutations({
      reset: 'packages/list/reset'
    }),

    submit () {
      let finalObject
      finalObject = JSON.parse(JSON.stringify(this.item))
      finalObject.customFieldValues = JSON.stringify(finalObject.customFieldValues)
      this.$emit('submit', finalObject)
    },

    addNewFieldToCustomField () {
      this.item.customFieldValues.push({ text: '', value: '' })
    },
    removeFieldFromCustomField (fieldValueIndex) {
      this.item.customFieldValues.splice(fieldValueIndex, 1)
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>

<style scoped>
</style>
